import HeroSection from "../components/me/Me"
import ScrollTimeline from "../components/Timeline/Timeline"
import styles from "./ForthScreen.module.css"
const ForthScreen=()=>{

    return <>
    <div className={styles.title}>חשוב לי שתדעי</div>
<div className={styles.description}>אמנם הצלחה בתחום נשמעת כמו חלום ורוד של כל אישה, אבל כדי להגיע למצב שהיומן שלך מלא, את מתמחרת את עצמך במחירים גבוהים ואת שולטת בהכנסות שלך כל חודש מחדש </div>
<div className={styles.title}>את תצטרכי להצטייד ב:</div>
<ScrollTimeline/>

   </>
}
export default ForthScreen